import React, { useState, useEffect } from "react";
import { Alert } from "react-bootstrap";
import PageHelmet from "../components/PageHelmet.jsx";
import CustomDataGrid from "../components/CustomDataGrid.jsx";
import { MdArrowBackIos } from "react-icons/md";
import {
    generateGridRows,
    generateGridColumns,
    existingActivitiesGridColumns,
    existingActivitiesRowMapping,
    activityMapping,
    generateFormData,
} from "../utils/PageUtils.js";
import EntityDetails from "../components/EntityDetails.jsx";
import '../styles/Activities.css';
import { fetchUserActivityLogs } from "../utils/api";

function MyActivity({ userRole, bearerToken }) {
    const [activities, setActivities] = useState([]);
    const [activityError, setActivityError] = useState(null);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleCloseActivityDetails = () => {
        setSelectedActivity(null);
        setSelectedRowId(null);
    }

    useEffect(() => {
        const fetchActivites = async () => {
            try {
                const response = await fetchUserActivityLogs(bearerToken)
                if (response.success) {
                    setActivities(response.data.records);
                }
                else {
                    setActivityError(response.message);
                }
            } catch (error) {
                setActivityError("Unable to fetch Activities");
            }
        }
        fetchActivites();
    }, []);

    const existingActivitiesRows = generateGridRows(activities, existingActivitiesRowMapping);
    const existingActivitiesColumns = generateGridColumns(existingActivitiesGridColumns, 'action');

    const activityAdditionalDetails = selectedActivity ? generateFormData(selectedActivity, activityMapping) : null;

    const handleRowClick = (params) => {
        setActivityError(null);
        if (selectedRowId === params.id) {
            setSelectedRowId(null);
            setSelectedActivity(null);
            return;
        }
        const activity = activities[params.id - 1];
        setSelectedActivity(activity);
        setSelectedRowId(params.id);

    }

    if (userRole !== "customer") {
        return (
            <div className="user-error">
                <h1>404 - Page Not Found</h1>
                <p>The page you're looking for doesn't exist.</p>
            </div>
        );
    }
    return (
        <div style={{ margin: "20px" }}>
            <PageHelmet
                title="My Activity"
                description="Track user activities and actions within the application"
                url={`${process.env.REACT_APP_COGNITO_REDIRECT_URL}/my-activity`}
            />
            {activityError && (
                <div >
                    <Alert variant="danger">{activityError}</Alert>
                </div>
            )}
            {!activityError && (
                <div className={`activities-container ${selectedActivity ? 'with-details' : 'centered'}`}>
                    <div className="activity-datagrid">
                        <h3 className="title-color">Activity Logs</h3>
                        <CustomDataGrid
                            rows={existingActivitiesRows}
                            columns={existingActivitiesColumns}
                            totalRows={existingActivitiesRows.length}
                            onRowClick={handleRowClick}
                            selectedRowId={selectedRowId}
                        />
                    </div>

                    {/* Desktop details */}
                    {!isMobile && selectedActivity && (
                        <div className="activity-details">
                            <h3 style={{ fontWeight: 'bolder' }}>Activity Details</h3>
                            <EntityDetails inputs={activityAdditionalDetails} width={'135px'} />
                        </div>
                    )}

                    {/* Mobile full-screen details */}
                    {isMobile && selectedActivity && (
                        <div className="activity-details mobile-open">
                            <div className="activity-details-header">
                                <div className="mobile-detail-nav">
                                    <button className="back-btn" onClick={handleCloseActivityDetails} aria-label="Back">
                                        <MdArrowBackIos size={18} />
                                    </button>
                                    <div className="mobile-activity-title">{selectedActivity?.action || 'Activity Details'}</div>
                                </div>
                            </div>
                            <div className="activity-details-body">
                                <EntityDetails inputs={activityAdditionalDetails} width={'135px'} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default MyActivity;